import { Helmet } from "react-helmet-async"
import { WhatsAppTemplatesList } from "../../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function WhatsAppIntegrationTemplatesPage() {
	const context = useOutletContext<{
		integrationId: number
		appId: number
	}>()

	return (
		<>
			<Helmet>
				<title>Templates | WA</title>
			</Helmet>
			<WhatsAppTemplatesList
				integratedAppId={context.appId}
				integrationId={context.integrationId}
			/>
		</>
	)
}
